import React, { useState } from "react";
import ImageUploader from "react-images-upload";
import PropTypes from "prop-types";
import { toBase64 } from "../../utils";
import { useSnackbar } from "notistack";
import { useTranslation } from "react-i18next";

const ImageUpload = ({ buttonText = "Choose image", onSuccess = () => {} }) => {
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();

  const [uploadedImage, setUploadedImage] = useState("");

  const handleChange = async file => {
    const [image] = file;

    if (!image) return;

    const base64Image = await toBase64(image).catch(error => Error(error));

    if (base64Image instanceof Error)
      return enqueueSnackbar(t("components.image_upload.upload_error"), {
        variant: "error"
      });

    onSuccess(base64Image);
    setUploadedImage(base64Image);
  };

  return (
    <>
      {uploadedImage && (
        <img src={uploadedImage} alt="" style={{ maxWidth: "100%" }} />
      )}
      <ImageUploader
        withIcon={true}
        buttonText={
          !uploadedImage
            ? buttonText
            : t("components.image_upload.upload_new_image")
        }
        onChange={file => handleChange(file)}
        imgExtension={[".jpg", ".gif", ".png", ".jpeg"]}
        maxFileSize={2000000}
        label="Max file size: 2mb"
        singleImage={true}
        fileSizeError={t("components.image_upload.file_size_error")}
        fileContainerStyle={{ boxShadow: "none" }}
      />
    </>
  );
};

ImageUpload.propTypes = {
  buttonText: PropTypes.string,
  onSuccess: PropTypes.func
};

export { ImageUpload };
